import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 3c7.18 0 13 5.82 13 13s-5.82 13-13 13S3 23.18 3 16 8.82 3 16 3m0 2C9.925 5 5 9.925 5 16s4.925 11 11 11 11-4.925 11-11S22.075 5 16 5m-3.293 6.293-.094-.083a1 1 0 0 0-1.32 1.497L14.585 16l-3.292 3.293-.083.094a1 1 0 0 0 1.497 1.32L16 17.415l3.293 3.292.094.083a1 1 0 0 0 1.32-1.497L17.415 16l3.292-3.293.083-.094a1 1 0 0 0-1.497-1.32L16 14.585z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconXCircle = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconXCircle);
export default Memo;
